import type { Components, Theme } from "@mui/material/styles";

export const MuiDialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[800]}`,
      minWidth: theme.spacing(80),
    }),
  },
};
